import * as tslib_1 from "tslib";
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import getMailboxForwardingConfigurationService from '../services/getMailboxForwardingConfigurationService';
export default action('initMailboxForwardingConfiguration')(function initMailboxForwardingConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = store;
                    return [4 /*yield*/, getMailboxForwardingConfigurationService()];
                case 1:
                    _a.mailboxForwardingConfiguration = _b.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initMailboxForwardingConfiguration.js.map